import { ISelectOption } from '../interfaces';
import { LinkBlockExtension } from './extensions/link-block';
import { ArticleExtension } from './extensions/article';
import {
  BaseExtension,
  FontFamilyExtension,
  ImageExtension,
  LinkExtension,
  ListItemExtension,
  TableKitExtension,
  TextAlignExtension,
  TextStyleExtension,
} from './extensions/base';
import { DivExtension } from './extensions/div';
import { GlobalAttrsExtension } from './extensions/global';
import { IFrameExtension } from './extensions/iframe';
import { ScriptExtension } from './extensions/script';
import { SectionExtension } from './extensions/section';
import { SpanExtension } from './extensions/span';
import { StyleExtension } from './extensions/style';

/**
 * Editable link attributes
 */
export const editableLink = {
  href: '',
  target: '_blank',
  type: 'URL',
};

/**
 * Editable image attributes
 */
export const editableImage = {
  style: 'width: 400px',
  align: '',
  alt: '',
  src: '',
};

/**
 * Editable table attributes
 */
export const editableTable = {
  style: 'width: 100%',
  width: '100%',
  border: '1',
  align: '',
  cellpadding: '1',
  cellspacing: '1',
};

/**
 * Text format select options
 */
export const textFormats: ISelectOption<string>[] = [
  {
    value: 'paragraph',
    text: 'Paragraph',
  },
  {
    value: 'heading.1',
    text: 'Heading 1',
  },
  {
    value: 'heading.2',
    text: 'Heading 2',
  },
  {
    value: 'heading.3',
    text: 'Heading 3',
  },
];

export const fontFamilies: ISelectOption<string>[] = [
  {
    value: 'sans-serif',
    text: 'Sans Serif',
  },
  {
    value: 'serif',
    text: 'Serif',
  },
  {
    value: 'monospace',
    text: 'Monospace',
  },
];

/**
 * Select options for link type
 */
export const linkTypes: ISelectOption<string>[] = [
  { text: 'URL', value: 'URL' },
  { text: 'Email', value: 'Email' },
  { text: 'Phone', value: 'Phone' },
];

/**
 * Select options for linked target attribute.
 */
export const targetTypes: ISelectOption<string>[] = [
  { text: 'Same Window', value: '' },
  { text: 'New Window', value: '_blank' },
];

/**
 * Align options basic
 */
export const alignOptions: ISelectOption<string>[] = [
  { text: 'None', value: '' },
  { text: 'Left', value: 'left' },
  { text: 'Right', value: 'right' },
];

/**
 * Table align options
 */
export const tblAlignOptions: ISelectOption<string>[] = [
  { text: 'None', value: '' },
  { text: 'Left', value: 'left' },
  { text: 'Center', value: 'center' },
  { text: 'Right', value: 'right' },
];

/**
 * TipTap Static Extensions (excluding FileHandlerExtension which is a function returning an extension)
 * Used by the main editor instance as well as HTML / JSON parsing between editor and persisted content.
 */
export const extensions = [
  GlobalAttrsExtension,
  TableKitExtension,
  BaseExtension,
  LinkExtension,
  LinkBlockExtension,
  ListItemExtension,
  TextAlignExtension,
  ImageExtension,
  FontFamilyExtension,
  TextStyleExtension,
  DivExtension,
  SectionExtension,
  ArticleExtension,
  SpanExtension,
  ScriptExtension,
  IFrameExtension,
  StyleExtension,
];
